import { render } from "./InboxIndex.vue?vue&type=template&id=9d207de2"
import script from "./InboxIndex.vue?vue&type=script&lang=js"
export * from "./InboxIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__